import { Alert, CircularProgress, Stack } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { D365TextField } from '@/components/D365FormControls';
import { RecordFormLayout } from '@/components/RecordFormLayout';
import { createClientNote, getClientNotes, updateClientNote } from '@/features/clients/api/clients';
export function NoteFormPage() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const p = useParams();
  const clientId = Number(p.clientId);
  const isNew = p.noteId === 'new';
  const id = Number(p.noteId);
  const [note, setNote] = useState('');
  const q = useQuery({
    queryKey: ['clients', clientId, 'notes'],
    queryFn: () => getClientNotes(clientId),
    enabled: !isNew,
  });
  const item = q.data?.find((x) => x.id === id);
  useEffect(() => {
    // The API result is the initial value for this routed editor.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (item) setNote(item.note);
  }, [item]);
  const m = useMutation({
    mutationFn: () =>
      isNew ? createClientNote(clientId, note.trim()) : updateClientNote(clientId, id, note.trim()),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['clients', clientId, 'notes'] });
      void nav(`/clients/${clientId}`);
    },
  });
  if (!isNew && q.isLoading)
    return (
      <Stack alignItems="center" sx={{ p: 8 }}>
        <CircularProgress />
      </Stack>
    );
  if (!isNew && !item)
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        This note could not be loaded.
      </Alert>
    );
  return (
    <RecordFormLayout
      title={isNew ? 'New Note' : 'Edit Note'}
      type="Note"
      saving={m.isPending}
      disabled={!note.trim()}
      dirty={isNew ? Boolean(note.trim()) : note !== item?.note}
      error={m.isError}
      onBack={() => void nav(`/clients/${clientId}`)}
      onSave={() => m.mutate()}
    >
      <D365TextField
        multiline
        minRows={10}
        label="Note"
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
    </RecordFormLayout>
  );
}

